import {Fragment, useState} from 'react';
import PropTypes from 'prop-types';
import {Accordion, Icon} from 'semantic-ui-react';
import Homeworks from './homeworks';
import Fetcher from '../shared/fetches/fetcher';
import StartStudentCourse from '../shared/start-student-course';
import Error from '../shared/error';
import {fetchStudentCourse} from '../../redux/actions/student-course';

function StudentCourseAccordion(props) {
  const {studentCourse} = props;
  const [activeId, setActiveId] = useState(studentCourse.id);

  const isActive = (studentCourse.id === activeId);
  const isDone = (studentCourse.status === 2);

  return (
    <div className='p-1'>
      <Accordion fluid styled>
        <Fragment>
          <Accordion.Title
            active={isActive}
            index={studentCourse.id}
            onClick={handleClick.bind(null, activeId, setActiveId)}
          >
            <Icon name='dropdown'/>
            {`${studentCourse.name} (${isDone ? 'انجام شده' : 'در حال انجام'})`}
          </Accordion.Title>
          <Accordion.Content active={isActive}>
            {isActive && (
              <Fetcher
                action={fetchStudentCourse.bind(null, studentCourse.id)}
                stateSelector={state => state.studentCourse}
                renderEmpty={renderEmpty.bind(null, studentCourse.id)}
                renderError={renderError.bind(null, studentCourse.id)}
              >
                {studentCourse => (
                  <Homeworks
                    name={studentCourse.name}
                    course={studentCourse.course}
                    doneHomeworks={studentCourse.homeworks}
                    reviewCount={studentCourse.reviewCount}
                    relatedStudentCourses={studentCourse.relatedStudentCourses}
                    color='orange'
                  />
                )}
              </Fetcher>
            )}
          </Accordion.Content>
        </Fragment>
      </Accordion>
    </div>
  );
}

function handleClick(activeId, setActiveId, event, item) {
  setActiveId(activeId !== item.index ? item.index : 0);
}

function renderEmpty(studentCourseId) {
  return (<StartStudentCourse studentCourseId={studentCourseId}/>);
}

function renderError(studentCourseId, error) {
  if (error.status === 404)
    return (<StartStudentCourse studentCourseId={studentCourseId}/>);
  return (<Error/>);
}

StudentCourseAccordion.propTypes = {
  studentCourse: PropTypes.object.isRequired
};

export default StudentCourseAccordion;
